import React from 'react';

import { AuthProvider } from './auth';
import { LoaderProvider } from './loader';
import { ToastProvider } from './toast';
import { ResultsProvider } from './results';
import { ResultProvider } from './result';

const AppProvider = ({ children }) => (
  <LoaderProvider>
    <AuthProvider>
      <ToastProvider>
        <ResultsProvider>
          <ResultProvider>{children}</ResultProvider>
        </ResultsProvider>
      </ToastProvider>
    </AuthProvider>
  </LoaderProvider>
);
export default AppProvider;
